var _circle, _circle2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgAgeRestricted = function SvgAgeRestricted(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 120,
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 60,
    fill: "url(#a)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "b",
    width: 120,
    height: 120,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 60,
    fill: "#6B0707"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 44,
    fill: "#F87C86"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9B0B17",
    d: "M51.258 77H30.535L26.5 73l11.008-8.129c1.445-1.51 2.565-2.721 3.36-3.633.806-.911 1.373-1.686 1.698-2.324a4.33 4.33 0 0 0 .489-1.992c0-.846-.274-1.458-.82-1.836-.547-.378-1.192-.566-1.934-.566-.899 0-1.81.26-2.735.78-.911.509-1.946 1.264-3.105 2.266l-3.997-3.996-.241-.965a32.42 32.42 0 0 1 2.734-2.187c.964-.703 2.103-1.276 3.418-1.719 1.315-.442 2.917-.664 4.805-.664 1.94 0 2.014-2.005 3.433-1.328 0 0 3.354 3.348 4.016 4.016.34.344.644.718.91 1.12.781 1.173 1.172 2.507 1.172 4.005 0 1.653-.306 3.131-.918 4.433-.599 1.29-1.504 2.585-2.715 3.887-1.21 1.289-2.721 2.754-4.531 4.394l-2.09 1.876v.195l6.803-4 3.998 4V77ZM71.18 77h-7.832l-3.998-4 3.998-10.121v-1.426c0-.703.006-1.478.02-2.324.025-.846.058-1.608.097-2.285-.339.403-.658.748-.957 1.035-.287.286-.567.553-.84.8l-3.242 2.676-3.996-3.995 9.797-8.915 2.955-3.995 3.998 3.995V77ZM90.535 60.281l3.285-4.001 4 4.001v5.235h-7.285v7.05h-5.234L81.3 68.57l4-3.054h-7.284l-3.996-4L85.3 60.28l1.24-11.171 3.995 4.003v7.168Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M47.258 73H26.535v-5.078l6.973-7.05c1.445-1.511 2.565-2.722 3.36-3.634.806-.911 1.373-1.686 1.698-2.324a4.33 4.33 0 0 0 .489-1.992c0-.846-.274-1.458-.82-1.836-.547-.378-1.192-.566-1.934-.566-.899 0-1.81.26-2.735.78-.911.509-1.946 1.264-3.105 2.266l-4.238-4.96a32.42 32.42 0 0 1 2.734-2.188c.964-.703 2.103-1.276 3.418-1.719 1.315-.442 2.917-.664 4.805-.664 1.94 0 3.62.339 5.039 1.016 1.432.677 2.539 1.608 3.32 2.793.781 1.172 1.172 2.506 1.172 4.004 0 1.653-.306 3.131-.918 4.433-.599 1.29-1.504 2.585-2.715 3.887-1.21 1.289-2.721 2.754-4.531 4.395l-2.09 1.874v.196h10.8V73ZM67.18 73h-7.832V57.453c0-.703.006-1.478.02-2.324a86.01 86.01 0 0 1 .097-2.285c-.339.403-.658.748-.957 1.035-.287.286-.567.553-.84.8l-3.242 2.676-4.004-4.921 9.805-7.989h6.953V73ZM86.535 56.281h7.285v5.235h-7.285v7.05h-5.234v-7.05h-7.285V56.28H81.3v-7.168h5.234v7.168Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 60,
    x2: 60,
    y1: 0,
    y2: 120,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.047,
    stopColor: "#FFC7D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBED9"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAgeRestricted);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "age-restricted.8b10d868b82f8c3f5980311f87908c83.svg";